import createHostComponent from '../../createHostComponent';
var WebView = createHostComponent('web-view', null);
export default WebView;
